import React, { useRef } from 'react';
import QRCode from 'qrcode.react';
import { Button } from 'antd';

/**
 * OrderTypeTag props
 */
interface Props {
  url: string;
}

/**
 * OrderTypeTag Component
 */
const QRCodeGenerator: React.FC<Props> = ({ url }) => {
  const qrRef = useRef<HTMLDivElement | null>(null);

  const downloadQRCode = () => {
    if (qrRef.current) {
      const canvas = qrRef.current.querySelector('canvas');
      const link = document.createElement('a');
      if (canvas) {
        link.href = canvas.toDataURL('image/png');
        link.download = 'qrcode.png';
        link.click();
      }
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        textAlign: 'center',
        textDecoration: 'none',
      }}>
      <div ref={qrRef} style={{ marginBottom: '10px' }}>
        <QRCode value={url} size={200} />
      </div>
      <a
        href={url}
        className="m-2 text-underline"
        target="_blank"
        rel="noreferrer">
        {url}
      </a>
      <Button onClick={downloadQRCode}>Download QR Code</Button>
    </div>
  );
};

export default QRCodeGenerator;
